import React, { Component } from 'react';
import './PMNew.css';
import PMAssignedTable from './PMAssignedTable';
import PMProjectSearch from './PMProjectSearch';
import PMBPSearch from './PMBPSearch';
import { Spinner } from '@blueprintjs/core';

class PMHome extends Component {

	render() {
		const p = this.props;
		if (p.reduxData.loading) {
			return this.loading();
		}

		return (
			<div className={"PMHome page"}>

				<div className={"topheader"}>
					<div className={"topheader_left"}>

					</div>
					<div className={"topheader_right"}>

					</div>
				</div>

				<div className="content">
					<div className="content_center">
						<div className={"content_header"}>
							<div className={"content_header_title"}>
								Home
								</div>
						</div>
						<div className={"content_panel"}>
							{this.assigned()}
						</div>
						<div className={"content_panel"}>
							{this.search()}
						</div>
					</div>
				</div>

			</div>
		);
	}

	loading = () => {
		return <div style={{ textAlign: 'center' }}>
			<Spinner />
		</div>;
	}

	assigned = () => {
		const p = this.props;
		return (
			<div className={"PMHomeAssigned"}>
				<PMAssignedTable
					assignments={p.reduxData.storedProjects}
					users={p.reduxData.storedUsers}
					currentUserIndex={p.reduxData.currentUserIndex}
					selectBP={p.selectBP}
				/>
			</div>
		)
	}

	search = () => {
		const p = this.props;
		return (
			<div className={"PMHomeProjects"}>
				<PMBPSearch changeMode={p.changeMode} selectBPFromSearch={p.selectBPFromSearch} />
				<PMProjectSearch changeMode={p.changeMode} selectProjectFromSearch={p.selectProjectFromSearch} />
			</div>
		)
	}
}

export default PMHome;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/PMHome.js